import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { MuiTelInput } from 'mui-tel-input'
import { getCountryCodeFromBrowserTimeZone } from '../../../utils/tzToCountry'

const defaultCountry = getCountryCodeFromBrowserTimeZone('IL')

// ----------------------------------------------------------------------

RHFPhoneInput.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
};

export default function RHFPhoneInput({ name, helperText, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <MuiTelInput
          disableFormatting
          {...field}
          fullWidth
          value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
          error={!!error}
          helperText={error ? error?.message : helperText}
          defaultCountry={defaultCountry}
          InputProps={{ style: { direction: 'ltr' } }}
          {...other}
        />
      )}
    />
  );
}
